import { makeStyles } from 'transfix-ui/core'

export const useCarrierProfilePageStyles = makeStyles(theme => ({
  cardsContainer: {
    display: 'grid',
    gap: theme.spacing(2.5),
  },
}))
